export default __webpack_public_path__ + "static/media/logo-3.3a240d7e.png";